"use client";

import React, { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
import { Link } from "@/components/common/Link";
export default function DarkStreetwearBanner() {
  const [offset, setOffset] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setOffset(window.scrollY * 0.4);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  return <section data-section-id="225286" id="global-metal-logistics" className="bg-background text-foreground relative h-screen w-full overflow-hidden flex flex-col items-center justify-center">
      {}
      <div className="absolute inset-0 z-0 bg-background">
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/urban_nightlife_cinematic_bg.png" alt="Industrial Bulk Carrier Loading" className="w-full h-full object-cover opacity-30 grayscale contrast-125" />
        {}
        <div className="absolute inset-0 bg-[url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1639953/img/noise_texture.png')] opacity-10 mix-blend-overlay pointer-events-none"></div>
      </div>

      {}
      <div className="relative z-10 flex flex-col items-center justify-center w-full px-4 will-change-transform" style={{
      transform: `translateY(${offset}px)`
    }}>
        <h1 className="text-[10vw] font-default font-bold leading-[0.85] tracking-tighter text-center uppercase text-foreground drop-shadow-2xl">
          MOVING THE WORLD'S IRON
          <span className="block mt-6 text-[2.5vw] text-primary font-mono tracking-widest">
            NORTH AMERICAN SCRAP. GLOBAL STEEL SOLUTIONS.
          </span>
        </h1>

        <div className="mt-12 md:mt-16">
          <Link to="#">
            
          </Link>
        </div>
      </div>

      {}
      <div className="absolute bottom-8 md:bottom-12 left-1/2 -translate-x-1/2 flex flex-col items-center gap-4 z-20">
        
        <Separator orientation="vertical" className="h-12 md:h-16 bg-primary animate-pulse" />
      </div>
    </section>;
}